<div class="card mb-5">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column align-items-center">
      <h4 style="margin: 0;">{{ data.title }}</h4>
    </div>
  </div>

  <div class="legend-wrapper" *ngIf="!hasError && legendItems.length > 0">
    <button *ngIf="showLeftArrow" (click)="scrollLegend('left')" class="scroll-arrow left">
      &lt;
    </button>

    <div #legendContainer class="custom-legend-container" (scroll)="updateArrowVisibility()">
      <div *ngFor="let item of legendItems" class="legend-item" [class.active]="activeLegend === item.name"
        [class.dimmed]="activeLegend !== null && activeLegend !== item.name" (click)="toggleLegend(item.name)"
        style="cursor: pointer;">
        <span class="legend-color-box" [style.background-color]="item.color"></span>
        <span class="legend-label">{{ item.name }}</span>
      </div>
    </div>

    <button *ngIf="showRightArrow" (click)="scrollLegend('right')" class="scroll-arrow right">
      &gt;
    </button>
  </div>

  <div class="card-body">
    <div [class.hidden]="hasError">
      <div [id]="data.widgetId" [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'" style="width: 100%">
      </div>
    </div>
  </div>

  <ng-template [ngIf]="hasError">
    <app-data-error [message]="errorMessage" />
  </ng-template>
</div>
